import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { // Consolidated Onboarding Keys
ONBOARDING_MARKETING_FREE, ONBOARDING_SALES_FREE, ONBOARDING_CMS_FREE, ONBOARDING_FREE_SERVICE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS, setOnboardingSettings } from 'user-context/onboardingSettings';
import { setDefaultGroupKey } from 'user-context/onboarding';
import { isUngatedFor } from '../utils/authUtils';
import { HubletUrl } from '../utils/urls';
import { BLOG_NEW_ONBOARDING_FLOW } from '../constants/gateConstants';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';
export const getDefaultOnboardingSettings = (isUsageWizardOnboardingVariant = false, isUngatedForNewBlogOnboarding = false) => {
  const {
    SALES,
    MARKETING,
    SERVICE,
    CMS
  } = ONBOARDING_VIEWS;

  if (isUsageWizardOnboardingVariant) {
    return {
      views: {
        [MARKETING]: {
          groupKey: FREE_GROUP_KEYS.freeMarketingViewWizard,
          onboardingKey: ONBOARDING_MARKETING_FREE
        },
        [SALES]: {
          groupKey: FREE_GROUP_KEYS.freeSalesViewWizard,
          onboardingKey: ONBOARDING_SALES_FREE
        },
        [SERVICE]: {
          groupKey: FREE_GROUP_KEYS.freeServiceViewWizard,
          onboardingKey: ONBOARDING_FREE_SERVICE
        },
        [CMS]: {
          groupKey: isUngatedForNewBlogOnboarding ? FREE_GROUP_KEYS.freeCmsViewWizardV2 : FREE_GROUP_KEYS.freeCmsViewWizard,
          onboardingKey: ONBOARDING_CMS_FREE
        }
      }
    };
  }

  return {
    views: {
      [MARKETING]: {
        groupKey: FREE_GROUP_KEYS.freeMarketingView,
        onboardingKey: ONBOARDING_MARKETING_FREE
      },
      [SALES]: {
        groupKey: FREE_GROUP_KEYS.freeSalesView,
        onboardingKey: ONBOARDING_SALES_FREE
      },
      [SERVICE]: {
        groupKey: FREE_GROUP_KEYS.freeServiceView,
        onboardingKey: ONBOARDING_FREE_SERVICE
      },
      [CMS]: {
        groupKey: isUngatedForNewBlogOnboarding ? FREE_GROUP_KEYS.freeCmsViewV2 : FREE_GROUP_KEYS.freeCmsView,
        onboardingKey: ONBOARDING_CMS_FREE
      }
    }
  };
};
export const setDefaultOnboardingSettings = (survey, hubOnboardingSettings, signupType, auth, portalId, logger, signupExperimentTreatments) => {
  if (!auth.userId) {
    if (logger) {
      logger.error('No user id provided, skipping setting onboarding key');
    }

    return Promise.resolve();
  }

  if (!portalId) {
    if (logger) {
      logger.error('No portal id provided, skipping setting onboarding key');
    }

    return Promise.resolve();
  }

  const {
    view = ONBOARDING_VIEWS.SALES
  } = hubOnboardingSettings,
        overrideOnboardingSettings = _objectWithoutPropertiesLoose(hubOnboardingSettings, ["view"]);

  const isUsageWizardOnboardingVariant = !!(signupExperimentTreatments && signupExperimentTreatments[ONBU025_EXPERIMENT_KEY] && signupExperimentTreatments[ONBU025_EXPERIMENT_KEY] === ONBU025_VARIANT_GROUP);
  const isUngatedForNewBlogOnboarding = auth.gates && isUngatedFor(auth, BLOG_NEW_ONBOARDING_FLOW);
  const onboardingSettings = getDefaultOnboardingSettings(isUsageWizardOnboardingVariant, isUngatedForNewBlogOnboarding);

  if (onboardingSettings.views) {
    onboardingSettings.views[view] = Object.assign({}, onboardingSettings.views[view], {}, overrideOnboardingSettings);
  } else {
    onboardingSettings.views = {
      [view]: overrideOnboardingSettings
    };
  }

  onboardingSettings.selectedView = view;
  const apiUrl = HubletUrl.getApiUrl();
  const requestOptions = {
    hubletOriginOverride: apiUrl
  };
  const settingsRequests = [setOnboardingSettings(onboardingSettings, auth.userId, portalId, requestOptions)]; // groupKey also needs to be set in usercontext-app for setting user's default task group

  if (onboardingSettings.views[view] && onboardingSettings.views[view].groupKey) {
    settingsRequests.push(setDefaultGroupKey(onboardingSettings.views[view].groupKey, requestOptions));
  }

  return Promise.all(settingsRequests);
};